import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import LeftBar from "./components/LeftBar";
import Header from "./components/Header";
import HeaderHome from "./components/Header-Home";
import UserLocationReporter from "./components/UserLocationReporter";

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [marginLeft, setMarginLeft] = useState("250px");
  const location = useLocation();

  const isHomeAcess = location.pathname.startsWith("/acess/home");

  const hideFullLayout =
    location.pathname.startsWith("/rastreamento/entrar") ||
    location.pathname.startsWith("/apidoc") ||
    location.pathname.startsWith("/entrar") ||
    location.pathname.startsWith("/cadastro") ||
    location.pathname.startsWith("/redefinir-senha") ||
    location.pathname.startsWith("/sessao-encerrada");

  const isMapView =
    location.pathname === "/coordenacao/colaboradores/visualizar-mapa";

  const hideHeader = hideFullLayout || location.pathname === "/menu/config";

  useEffect(() => {
    const updateMargin = () => {
      if (hideFullLayout || isHomeAcess) {
        setMarginLeft("0px");
      } else {
        setMarginLeft(window.innerWidth < 1000 ? "10px" : "70px");
      }
    };

    updateMargin();
    window.addEventListener("resize", updateMargin);
    return () => window.removeEventListener("resize", updateMargin);
  }, [hideFullLayout, isHomeAcess]);

  return (
    <div style={{ display: "flex" }}>
      <UserLocationReporter />

      {!hideFullLayout && !isHomeAcess && <LeftBar />}

      {!hideHeader && (isHomeAcess ? <HeaderHome /> : <Header />)}

      <div
        style={{
          flex: 1,
          marginLeft:
            hideFullLayout || isMapView || isHomeAcess ? "0px" : marginLeft,
          padding: hideFullLayout || isMapView || isHomeAcess ? "0px" : "20px",
          transition: "margin-left 0.3s ease",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
